module.exports = __webpack_public_path__ + "img/ico-download-ee.7e1a232d.svg";